import { MeshBuilder } from "@babylonjs/core/Meshes/meshBuilder";

// import TestShaderMaterial from "./Sky/SkyShaderMaterial"

import { Constants } from "@babylonjs/core/Engines/constants";


export default class PlayerSphere {

    constructor(scene) {

        this.mesh = buildMesh();

        // this.mat = new TestShaderMaterial(this.mesh)

        function buildMesh(shader) {
            const mesh = MeshBuilder.CreateSphere("playerSphere", { diameter: 12 }, scene);
            mesh.checkCollisions = true;
            mesh.receiveShadows = true;
            mesh.position.y = -10;

            return mesh
        }

    }
}

// if (module.hot) {

//     // let mat = new TestShaderMaterial(mesh);

//     module.hot.dispose(function () {
//         console.log("hey")
//     })

//     module.hot.accept(
//         function accept() {
//             // let mesh = game.scene.getMeshByName("playerSphere");

//             console.log(' * * * Change in shader detected!');
//             // game.scene.markAllMaterialsAsDirty(Constants.MATERIAL_AllDirtyFlag);

//             mesh.mat = mat.shaderMaterial

//             console.log(mat.fragmentShader);
//             // mesh.material.dispose();
//             // let mat = new TestShaderMaterial(mesh);

//             // mesh.material = mat.shaderMaterial
//             // console.log(mat.shaderMaterial)

//         })
// }
